import { useTranslation } from 'react-i18next';
import { ArrowDownLeft, ArrowUpRight } from 'lucide-react';
import styles from './DirectionChip.module.css';

/**
 * ALIS / SATIS yonu.
 *
 * Dolu yesil/kirmizi zemin yerine INCE CERCEVE: bu iki renk listede kazanc-kayip
 * sinyali olarak da kullaniliyor; dolu zeminler her karti "alarm" gibi
 * gosteriyordu (mobilde ayni karar verildi).
 *
 * Etiket metni ceviri dosyasinda BUYUK HARFLE yazili ('ALIŞ'/'SATIŞ');
 * text-transform kullanilmiyor — Turkce i/İ donusumu tarayici diline gore bozulur.
 */
export function DirectionChip({ isBuying }: { isBuying: boolean }) {
  const { t } = useTranslation();
  const Icon = isBuying ? ArrowDownLeft : ArrowUpRight;

  return (
    <span className={[styles.chip, isBuying ? styles.buy : styles.sell].join(' ')}>
      <Icon size={12} strokeWidth={2.6} aria-hidden="true" />
      {t(isBuying ? 'labels.buy' : 'labels.sell')}
    </span>
  );
}
